import { render, staticRenderFns } from "./QuestionPost.vue?vue&type=template&id=04a37c6a&"
import script from "./QuestionPost.vue?vue&type=script&lang=js&"
export * from "./QuestionPost.vue?vue&type=script&lang=js&"
import style0 from "./QuestionPost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports